export const colorControlCreate = (config = {}, changeFn) => {
  const control = L.Control.extend({
    option: {
      position: config['position'] || 'topright',
    },
    onAdd: function (iconMap) {
      const constructor = L.DomUtil.create('div', `leaflet-control leaflet-control-colorpicker`),
        input = L.DomUtil.create('input', `leaflet-control-colorpicker-input`, constructor);
      input.type = 'color';
      L.DomEvent.on(input, 'input', event => {
        changeFn && changeFn(event);
      });
      return constructor;
    }
  });
  return new control({
    ...config
  });
}

export const controlCreate = (config, type, initFun, className, position) => {
  const control = L.Control.extend({
    option: {
      position: position || 'topright',
    },
    onAdd: function (iconMap) {
      const constructor = L.DomUtil.create('div', `leaflet-control leaflet-control-${className}`),
        link = L.DomUtil.create('a', `leaflet-control-${className}-link`, constructor);
      link.href = '#'; link.title = config.title || '';
      if (config.html) {
        link.innerHTML = config.html;
      }
      if (type == 'click' && initFun) {
        L.DomEvent.on(link, "click", (event) => {
          L.DomEvent.stop(event);
          initFun();
        });
      } else if (type == 'content' && initFun) {
        initFun && initFun(constructor);
      }
      return constructor;
    }
  });
  return new control({
    ...config
  });
}

export const controlCreateMulti = (list, className, position, config) => {
  const control = L.Control.extend({
    option: {
      position: position || 'topright',
    },
    onAdd: function (iconMap) {
      const constructor = L.DomUtil.create('div', `leaflet-control leaflet-control-${className}`);
      for (const item of list) {
        const link = L.DomUtil.create('a', `leaflet-control-${item.className}-link`, constructor);
        link.href = '#'; link.title = item.title || '';
        if (item.html) {
          link.innerHTML = item.html
        }
        L.DomEvent.on(link, "click", (event) => {
          L.DomEvent.stop(event);
          item.fun();
        });
      }
      return constructor;
    }
  });
  return new control({
    ...config
  });
}

const ns = 'http://www.w3.org/2000/svg'; 
const childNS = 'http://www.w3.org/1999/xlink'; 
export const svgControlCreate = (config, type, initFun, className, position) => {
  const control = L.Control.extend({
    option: {
      position: position || 'topright',
    },
    onAdd: function (iconMap) {
      const constructor = L.DomUtil.create('div', `leaflet-control leaflet-control-${className}`),
        link = document.createElementNS(ns, 'svg'),
        use = document.createElementNS(ns, 'use');
      constructor.title = config.title || '';
      link.setAttribute('class', `leaflet-control-${className}-link svg-icon`);
      link.setAttributeNS(ns, 'aria-hidden', true);

      use.setAttributeNS(childNS, 'xlink:href', `#icon-${config.svgName}`);

      constructor.appendChild(link);
      link.appendChild(use);
      if (config.html) {
        link.innerHTML = config.html;
      }
      if (type == 'click' && initFun) {
        L.DomEvent.on(link, "click", (event) => {
          L.DomEvent.stop(event);
          initFun();
        });
      } else if (type == 'content' && initFun) {
        initFun && initFun(constructor);
      }
      return constructor;
    }
  });
  return new control({
    ...config
  });
}

export const svgControlCreateMulti = (list, className, position, config) => {
  const control = L.Control.extend({
    option: {
      position: position || 'topright',
    },
    onAdd: function (iconMap) {
      const constructor = L.DomUtil.create('div', `leaflet-control leaflet-control-${className}`);
      for (const item of list) {
        const a = L.DomUtil.create('a', undefined, constructor)
        const link = document.createElementNS(ns, 'svg'),
          use = document.createElementNS(ns, 'use')
        if (item.title) {
          a.title = item.title;
        }
        link.setAttributeNS(ns, 'aria-hidden', true);
        link.setAttribute('class', `leaflet-control-${className}-link svg-icon`);

        use.setAttributeNS(childNS, 'xlink:href', `#icon-${item.svgName}`);

        a.appendChild(link);
        link.appendChild(use);
        if (item.html) {
          link.innerHTML = item.html
        }
        L.DomEvent.on(link, "click", (event) => {
          L.DomEvent.stop(event);
          item.fun && item.fun();
        });
      }
      return constructor;
    }
  });
  return new control({
    ...config
  });
}
